import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom'
import DisponibilidadGrid from './DisponibilidadGrid.jsx'
import { FormattedMessage } from 'react-intl';


const Disponibilidad = ({ match }) => {

  return (
    <div className="content-wrapper">
      <div className="content-header row">
        <div className="content-header-left col-md-6 col-12 mb-2">
          <h3 className="content-header-title">
            <FormattedMessage
              id="disponibilidad.label_listado_disponibilidad"
              defaultMessage="Vehículos Ociosos"
            />
          </h3>
        </div>
      </div>
      <div className="content-body">
        <Switch>
          <Route exact path={`${match.url}`} component={DisponibilidadGrid} />
        </Switch>
      </div>
    </div>
  );
};

export default withRouter(Disponibilidad);